import Loader from '@/components/Includes/Loader/Loader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import Header from './CreateGroupHeader/CreateGroupHeader.vue';
import Row from './CreateGroupRow/CreateGroupRow.vue';

@Component({
    name: 'ChooseRole',
    components: {
        Row,
        Header,
        Loader
    }
})
export default class ChooseRole extends Vue {
    @Prop(Object) private group!: any;
    @Prop(Array) private id!: any;
    @Prop(Object) private userRoles!: any;
    @Prop(Boolean) private disabled!: boolean;
    @Action private rolesList!:() => Promise<void>;
    @Getter private getRolesList!: () => any;

    private roles:any = []
    private loading:boolean = false

    private get notEmpty() {
        return this.roles.length !== 0;
    }
    private handleRoleChanged ({ checked, value }:any) {
        this.group.roles = checked ? [...this.group.roles, value] : this.group.roles.filter((el:any) => el !== value);
    }

    private async mounted() {
        try {
            this.roles = this.getRolesList();

            if(!this.notEmpty) {
                await this.rolesList();
                this.roles = this.getRolesList();
            }

            this.loading = false;
        } catch {
            return void 0;
        }
    }
};